import React from 'react'

/**
 * @param onClick
 */
class FlagButton extends React.Component
{

    constructor(props)
    {
        super(props)
        this.state = {
            confirmClick: false
        }
    }

    render()
    {
        return this.state.confirmClick ? (
            <div style={ this.props.style } onClick={ this.props.onClick } className="dk-flag confirm">
                b
            </div>
        ) : (
            <div
                onClick={ () => {
                    this.setState({ confirmClick: true })
                    setTimeout(() => {
                        this.setState({ confirmClick: false })
                    }, 2000)
                } }
                style={{ fontFamily: "lichess", ...(this.props.style || {}) }}
                className="dk-button dk-box dk-flag-button">b</div>
        )
    }

}

export default FlagButton
export { FlagButton }